import React from "react";
import HeroVideo from "../components/HeroVideo";
import FeatureIcons from "../components/FeatureIcons";
import StatsSection from "../components/StatsSection";
import ServicesGrid from "../components/ServicesGrid";
import ProcessSection from "../components/ProcessSection";
import AboutSection from "../components/AboutSection";
import Testimonials from "../components/Testimonials";
import CTASection from "../components/CTASection";

export default function Home() {
  return (
    <>
      <HeroVideo />
      <FeatureIcons />
      <StatsSection />
      <ServicesGrid />
      <ProcessSection />
      <AboutSection />
      <Testimonials />
      <CTASection />
    </>
  );
}
